import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";

import { isAuthorized } from "@/utils/authToken";
import { providerRequests } from "@/api/(requests)/provider";

import images from "../../../../utils/images";
import { isConversationReadOnly, CONVERSATION_READ_ONLY_TYPES } from "../../../../utils/chatUtils";
import { Toggle } from "../../../../component-library";

export const ChatHeader = (props) => {
  const { channel, isMobile, showMenu, switchMobileView } = props;
  const profile = useSelector((state) => state.auth.profile);
  const isReadOnly = isConversationReadOnly(profile?.care_team_members, channel);
  const isProviderNoLongerOnCareTeamReadOnly =
    isReadOnly === CONVERSATION_READ_ONLY_TYPES.PROVIDER_NO_LONGER_ON_CARE_TEAM;
  const isUserPrescriber = isAuthorized("provider:prescribe");
  const otherMemberId = channel?.otherMembers?.length && channel?.otherMembers[0].userId;

  const onToggleRestrictPatientReplies = () => {
    const urlParams = { patientId: otherMemberId };
    const data = {
      channel_url: channel.url,
      patient_read_only_message_thread: !channel.otherMembers[0]?.isMuted,
    };

    providerRequests.toggle_patient_read_only_message_thread({
      data,
      urlParams,
    });
  };

  return (
    <div className="Messages__Chat__Header">
      {isMobile && (
        <img
          alt="back-arrow"
          className="back-arrow"
          onClick={switchMobileView}
          src={images("./icons/back-arrow.svg")}
        />
      )}
      <div className="d-flex justify-content-between w-100">
        <div>
          <img alt="avatar" className="avatar" src={channel.coverImage} />
          <span>
            <b>
              {channel.otherMembers.map((user) => (
                <React.Fragment key={user.userId}>
                  {user.nickname}
                  {user?.metaData?.preferred_name && (
                    <span className="preferred-name">{` (${user.metaData.preferred_name})`}</span>
                  )}
                  {user?.metaData?.preferred_pronouns && (
                    <span className="preferred-pronouns">
                      {` ${user.metaData.preferred_pronouns}`}
                    </span>
                  )}
                </React.Fragment>
              ))}
            </b>
          </span>
        </div>
        <div className="d-flex">
          {isUserPrescriber && (
            <div className="d-flex align-items-center">
              {channel.otherMembers[0].isMuted ? (
                <div className="d-flex flex-column">
                  <span className="bold">Replies restricted</span>
                  <span className="fs-12">
                    The patient will still receive your messages but can’t reply.
                  </span>
                </div>
              ) : (
                <div className="d-flex flex-column">
                  <span className="bold">Replies enabled</span>
                  <span className="fs-12">The patient can reply to messages in this thread.</span>
                </div>
              )}
              <Toggle
                checked={channel.otherMembers[0].isMuted}
                className="restrict-patient-replies-toggle"
                name="restrict_patient_replies_toggle"
                onClick={onToggleRestrictPatientReplies}
                testId="chat-header-restrict-patient-replies-toggle"
              />
            </div>
          )}
          {!isProviderNoLongerOnCareTeamReadOnly && (
            <div className="align-self-center" style={{ cursor: "pointer", marginRight: "10px" }}>
              <img
                alt="three dots menu"
                className="cursor"
                onClick={showMenu}
                role="button"
                src={images("./icons/three-dots-menu.svg")}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ChatHeader.propTypes = {
  channel: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  showMenu: PropTypes.func.isRequired,
  switchMobileView: PropTypes.func.isRequired,
};
